import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CalculatorsContext, DraftContext } from '../../context';

// Entry point for editing an existing calculator draft.
// Restores draft state by draftId and navigates to the last saved position or registration page.
// Uses DraftContext for draft info and CalculatorsContext for calculator list.
// Handles session restoration and navigation logic.

const EditAssessment = () => {
  const navigate = useNavigate();
  const { draftId } = useParams();

  const { calculatorsList } = useContext(CalculatorsContext);
  const { setDraftId, draft } = useContext(DraftContext);

  useEffect(() => {
    window.sessionStorage.removeItem('SELECTED_DRAFT_ID');
    setDraftId(null);
  }, []);

  useEffect(() => {
    if (!draftId) return;
    setDraftId(draftId);
  }, [draftId]);

  useEffect(() => {
    if (!calculatorsList || !calculatorsList.length || !draft) return;
    if (draft?.lastPosition) navigate(draft.lastPosition);
    else navigate('/registration', { replace: true });
  }, [calculatorsList, draft]);

  return <></>;
};

export default EditAssessment;
